






















































import {Vue, Component, PropSync} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {HmsType} from "@/store/push/application/types";
import {isEmpty} from "lodash";

@Component({
  components: {proxySettingsForm}
})
export default class HmsSettings extends Vue {
  @PropSync('hmsOptions') hms!: HmsType;

  get isHMSProxy(): boolean {
    return !isEmpty(this.hms.proxy_settings);
  }

  set isHMSProxy(value: boolean) {
    if (value) {
      this.$set(this.hms, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.hms, 'proxy_settings');
    }
  }
}
